<div class="gl-dashboard__title">
  <span>{{ 'dashboard.widgets.subscriptionActivation.title' | translate }}</span>
  <button
    type="button"
    lmsTooltip
    [tooltipConfig]="{
      positionV: 'bottom',
      positionH: 'left',
      text: 'dashboard.widgets.subscriptionActivation.tooltip' | translate
    }"
    class="un-btn"
  >
    <span class="glicon-info"></span>
  </button>
</div>
<div class="padding-top-gap">
  <gl-chart-bar
    width="97%"
    height="150px"
    [data]="chartData"
    [maxValue]="activation.totalSeats"
    [trendValue]="activation.seatsGoal"
    axisYElements="5"
    type="thin"
  >
    <div *ngIf="activation.percentGoal" class="subscription-activation__legend" slot="legend">
      <span class="subscription-activation__bullet"></span>
      <span
        [innerHTML]="
          'dashboard.widgets.subscriptionActivation.legend' | translate : { percentage: activation.percentGoal }
        "
      ></span>
    </div>
  </gl-chart-bar>
</div>
